import { useState, useEffect } from 'react';
import { supabase } from '../providers/supabase/supabase';

interface ArtistUrls {
    spotify_url: string | null;
    instagram_url: string | null;
    facebook_url: string | null;
    website_url: string | null;
    name: string | null;
}

export const useArtistUrls = (artistId: string | null | undefined) => {
    const [urls, setUrls] = useState<ArtistUrls | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!artistId) {
            setUrls(null);
            return;
        }

        const fetchArtistUrls = async () => {
            setLoading(true);
            setError(null);

            try {
                console.log('🔍 Fetching URLs for artist_id:', artistId);
                
                const { data, error: queryError } = await supabase
                    .from('artists')
                    .select('spotify_url, instagram_url, facebook_url, website_url, name')
                    .eq('id', artistId)
                    .maybeSingle(); // Use maybeSingle instead of single to avoid error if no rows

                if (queryError) {
                    throw queryError;
                }

                console.log('🎯 FETCHED ARTIST URLs:', data);
                setUrls(data);

            } catch (err) {
                console.error('❌ Error fetching artist URLs:', err);
                setError(err instanceof Error ? err.message : 'Failed to fetch URLs');
                setUrls(null);
            } finally {
                setLoading(false);
            }
        };

        fetchArtistUrls();
    }, [artistId]);

    return { urls, loading, error };
};